import {NfMessage, NfMessageType} from "../NfMessage";
import {NfComponentMessage} from "../NfComponentMessage";

/**
 * Wiadomość, gdy potrzebna jest konfiguracja widgeta, do service workera
 */
export class GetBookingEngineConfiguration extends NfComponentMessage {
    public constructor(widgetId: number|MessageEvent<GetBookingEngineConfiguration>) {
        super(NfMessageType.GetBookingEngineConfiguration);
        if(NfMessage.isMessageEvent(widgetId)) {
            Object.assign(this, widgetId.data);
        } else {
            this.widgetId = widgetId;
        }
    }
    public type = NfMessageType.GetBookingEngineConfiguration;
    /**
     * id widgeta dla backendu nfHotel
     */
    public widgetId:number = 0;
}
NfMessage.creationCallbacks[NfMessageType.GetBookingEngineConfiguration] = (event) => {
    const message =  new GetBookingEngineConfiguration(event);
    return message;
}
